import React from "react"
import classNames from "classnames"
import {withStyles} from "@material-ui/core";
import styles from "./styles"
import Header from "../Components/Header";
import TitleWithText from "../Components/TitleWithText";
import {translate} from "react-i18next";
import {compose} from "redux";
import Footer from "../Components/Footer";

const RouteServices = ({t, classes}) => {
    const hasVScroll = document.body.scrollHeight > document.body.clientHeight;
    return (
    <div className={classNames({[`${classes.root}`]: !hasVScroll})}>
        <Header activePage={"services"}/>
        <div className={classes.elements}>
            <div className={classes.textElements}>
                <TitleWithText title={t("main:services")} text={t("main:our_services")} titleSize={"35px"}/>
                <TitleWithText title={t("main:our_services_header2")} text={t("main:our_services2")}/>
                <TitleWithText title={t("main:our_services_header3")} text={t("main:our_services3")}/>
                <TitleWithText title={t("main:our_services_header4")} text={t("main:our_services4")}/>
            </div>
            <div className={classes.footer}>
                <Footer/>
            </div>
        </div>
    </div>
)};

export default compose(
    translate(),
    withStyles(styles)
)(RouteServices)